@if ((isMobile$ | async) === false) {
  <button color="primary" mat-stroked-button [matMenuTriggerFor]="columnMenu">
    <div class="centered-label">
      <mat-icon>{{ iconName }}</mat-icon>
      {{ buttonLabel }}
    </div>
  </button>
}
@if ((isMobile$ | async) === true) {
  <button color="primary" mat-icon-button [matMenuTriggerFor]="columnMenu">
    <mat-icon>{{ iconName }}</mat-icon>
  </button>
}
<mat-menu #columnMenu="matMenu">
  <div class="va-mat-table-dragable-container" cdkDropList dkDropListLockAxis="y" cdkDropListOrientation="vertical">
    @for (column of columnInfo; track column; let i = $index) {
      <div
        class="dragable-row"
        cdkDrag
        [cdkDragData]="{ columnIndex: i, columnTitle: column.id }"
        (cdkDragDropped)="columnMenuDropped($event)"
        >
        <mat-icon cdkDragHandle>drag_indicator</mat-icon>
        <mat-checkbox
          [checked]="!column.hidden"
          (click)="$event.stopPropagation()"
          (change)="toggleSelectedColumn(column.id)"
          >
          <ng-container *ngTemplateOutlet="nameOutput; context: { name: column.name }" />
        </mat-checkbox>
        <mat-card appearance="outlined" class="va-mat-table-drag-preview" *cdkDragPreview>
          <mat-icon>drag_indicator</mat-icon>
          <mat-checkbox [checked]="!column.hidden">
            <ng-container *ngTemplateOutlet="nameOutput; context: { name: column.name }" />
          </mat-checkbox>
        </mat-card>
      </div>
    }
  </div>
</mat-menu>
<ng-template #nameOutput let-name="name">
  @if (useI18NTranslations) {
    {{ name | translate }}
  }
  @if (!useI18NTranslations) {
    {{ name }}
  }
</ng-template>
